import constants from 'constants/notifications.js';

export const addFooterNotification = payload => {
  return {
    type: constants.ADD_FOOTER_NOTIFICATION,
    payload,
  };
};

export const deleteFooterNotification = () => {
  return {
    type: constants.DELETE_FOOTER_NOTIFICATION,
  };
};

export const addSnackbarNotification = payload => {
  return {
    type: constants.ADD_SNACKBAR_NOTIFICATION,
    payload,
  };
};

export const deleteSnackbarNotification = () => {
  return {
    type: constants.DELETE_SNACKBAR_NOTIFICATION,
  };
};

export const addDialogNotification = payload => {
  return {
    type: constants.ADD_DIALOG_ERROR_NOTIFICATION,
    payload,
  };
};

export const deleteDialogNotification = () => {
  return {
    type: constants.DELETE_DIALOG_ERROR_NOTIFICATION,
  };
};
